$.fn.solrProxy = function(options) {
  var defaults = {
    development: false,
    source: null,
    template: null,
    profile: null,
    more: null,
    start: 0,
    rows: null,
    sort: null,
    filter: null,
    onsite: null,
    instance: randomString(10),
    empty: null,
    spinner: null,
    found: null,
    counter: null,
    reset: null,
    show: null,
    afterEmpty: $.noop,
    beforeDocs: $.noop,
    afterDocs: $.noop,
    beforeFilter: $.noop,
    afterFilter: $.noop,
    afterReload: $.noop
  };
  var settings = $.extend({}, defaults, options);
  var initial = true;
  return this.each(function() {

    settings.source = $(this).data("source") || settings.source;
    settings.sort = $(this).data("sort") || settings.sort;
    settings.rows = $(this).data("rows") || settings.rows;

    if (typeof Handlebars !== "undefined") {
      if (settings.source) {
        if (settings.profile) {
          request(settings.start, true, true, false, $(this));
        } else {
          errorMessage("profile not available");
        }
      } else {
        errorMessage("source not available");
      }
    } else {
      errorMessage("handlebars not available");
    }
  });
  function request(start, reload, reset, getFilter, container) {
    var queryString = "";
    var filterString = "";
    var dataSize = "";
    var dataSort = "";
    var postTemplate = Search.Templates[settings.template];
    if (initial) {
      initial = false;
      if (settings.reset) {
        $(settings.reset).click(function(e) {
          request(settings.start, true, true, false, container);
          if (settings.list) {
            $(settings.list.container).empty();
          }
          e.preventDefault();
        });
      }
      if (settings.onsite) {
        if (settings.onsite.input) {
          $(settings.onsite.input).val(urlParam($(settings.onsite.input).attr("name")));
        }
      }
    }
    if (reload) {
      var moreCounter = settings.start;
      container.empty();
      settings.afterEmpty.call(this, settings.instance);
    } else {
      var moreCounter = start;
    }
    if (settings.onsite) {
      if (settings.onsite.input) {
        if (urlParam($(settings.onsite.input).attr("name"))) {
          queryString = "&q=" + encodeURIComponent(urlParam($(settings.onsite.input).attr("name")));
        } else {
          queryString = "&q=";
        }
      }
    }
    if (settings.spinner) {
      $(settings.spinner).show();
    }
    if (settings.empty) {
      $(settings.empty).hide();
    }
    if (settings.more) {
      $(settings.more).hide();
    }
    if (settings.show) {
      $(settings.show).hide();
    }
    if (settings.rows) {
      dataSize = "&rows=" + settings.rows;
    }
    if (settings.sort) {
      if (typeof settings.sort == 'object') {
        dataSort = "&sort=" + $("[name='" + settings.sort.name + "']:checked").val();
      } else {
        dataSort = "&sort=" + settings.sort;
      }
    }
    if (getFilter && settings.filter) {
      $.each(settings.filter, function(key, filter) {
        var values = "";
        $(filter.container).find('[data-filter-facet="true"]:checked').each(function() {
          filterString += "&f[" + filter.name + "]=" + encodeURIComponent($(this).val());
          values += $(this).val();
        });
        $(filter.container).find('[data-filter-facet="false"]').each(function() {
          filterString += "&" + filter.name + "=" + encodeURIComponent($(this).val());
          values += $(this).val();
        });
        if (values) {
          filter.checked = true;
        } else {
          filter.checked = false;
        }
        if (filter.dataDefault && !values) {
          $.each($(filter.container).attr(filter.dataDefault).split(","), function(key, item) {
            if (item.length > 0) {
              if (filter.separated) {
                filterString += "&" + filter.name + "=" + item;
              } else {
                filterString += "&f[" + filter.name + "]=" + item;
              }
            }
          });
        }
      });
    }
    if (!getFilter && reload && settings.filter) {
      $.each(settings.filter, function(key, filter) {
        if (filter.dataContainerDefault) {
          $.each(container.data(filter.dataContainerDefault).split(","), function(key, item) {
            if (item.length > 0) {
              if (filter.separated) {
                filterString += "&" + filter.name + "=" + item;
              } else {
                filterString += "&f[" + filter.name + "]=" + item;
              }
            }
          });
        }
        if (filter.default && filter.type) {
          $.each(filter.default.split(","), function(key, item) {
            if (item.length > 0) {
              if (filter.separated) {
                filterString += "&" + filter.name + "=" + item;
              } else {
                filterString += "&f[" + filter.name + "]=" + item;
              }
            }
          });
        }
        if (filter.dataDefault && filter.type && $(filter.container).attr(filter.dataDefault).length > 0) {
          $.each($(filter.container).attr(filter.dataDefault).split(","), function(key, item) {
            if (item.length > 0) {
              if (filter.separated) {
                filterString += "&" + filter.name + "=" + item;
              } else {
                filterString += "&f[" + filter.name + "]=" + item;
              }
            }
          });
        }
      });
    }
    var source = settings.source + "/" + settings.profile + "?start=" + start + dataSize + dataSort + queryString + filterString;
    $.ajax({
      url: source,
      cache: false,
      success: function(data) {
        if (typeof data === "object") {
          if (data.header.status === 0) {
            if (settings.more) {
              if (data.header.start + data.header.rows >= data.header.found) {
                $(settings.more).hide();
              } else {
                $(settings.more).show();
              }
            }
            if (settings.empty) {
              if (data.header.found === 0) {
                $(settings.empty).show();
              } else {
                $(settings.empty).hide();
              }
            }
            if (settings.found) {
              $(settings.found).html(data.header.found);
            }
            if (settings.counter) {
              if ((data.header.start + data.header.rows) / data.header.found < 1) {
                $(settings.counter).html(data.header.start + data.header.rows);
              } else {
                $(settings.counter).html(data.header.found);
              }
            }
            if (settings.sort) {
              if (typeof settings.sort == 'object') {
                $("[name='" + settings.sort.name + "']").unbind("change");
                $("[name='" + settings.sort.name + "']").change(function(e) {
                  request(settings.start, true, true, true, container);
                });
              }
            }
            if (settings.filter) {
              settings.beforeFilter.call(this, settings.instance);
              $.each(settings.filter, function(key, filter) {
                if (!filter.checked || reset) { // filter pills will only be recalculated if reset is true or (no item is checked and no default checked items were initialized)
                  if (filter.container) {
                    $(filter.container).empty();
                    var filterTemplate = Search.Templates[filter.template];
                    var filterHtml, filterFacet, filterPresent;
                    var filterObj = data.facets[filter.name];
                    if (filterObj && !filter.separated) {
                      filterHtml = $.parseHTML(filterTemplate(filterObj));
                      filterFacet = true;
                    } else {
                      filterHtml = $.parseHTML(filterTemplate({}));
                      filterFacet = false;
                    }

                    if (filterObj) {
                      if (filterObj.length === 0) {
                          filterPresent = false;
                      } else if (filterObj.length === 1) {
                          if (filterObj[0].value) {
                              filterPresent = true;
                          } else {
                              filterPresent = false;
                          }
                      } else {
                          filterPresent = true;
                      }
                    } else {
                      filterPresent = true;
                    }

                    if (filterPresent) {
                      $(filter.container).append(filterHtml).attr("data-filter-instance", settings.instance);
                      $(filter.container).find("option, input").attr({
                        name: filter.name + "_" + settings.instance,
                        "data-filter-name": filter.name,
                        "data-filter-facet": filterFacet
                      });
                      if (filter.default && filter.type) {
                        $.each(filter.default.split(","), function(key, item) {
                          defaultFilterSet(filter, item);
                        });
                      }
                      if (filter.dataDefault && filter.type && $(filter.container).attr(filter.dataDefault).length > 0) {
                        $.each($(filter.container).attr(filter.dataDefault).split(","), function(key, item) {
                          defaultFilterSet(filter, item);
                        });
                      }
                    } else {
                      if (filter.empty) {
                        var filterEmptyTemplate = Search.Templates[filter.empty];
                        var filterEmptyHtml = $.parseHTML(filterEmptyTemplate({}));
                        $(filter.container).append(filterEmptyHtml);
                      }
                    }
                    if (filter.found) {
                      $(filter.found).append(data.header.found);
                    }
                    $(filter.container).unbind("change");
                    $(filter.container).change(function(e) {
                      moreCounter = settings.start;
                      request(settings.start, true, false, true, container);
                      if (settings.list) {
                        var listItemTarget = e.target;
                        var listItemTemplate = Search.Templates[settings.list.template];
                        var listItemHtml = listItemTemplate({
                          id: e.target.id + "_list",
                          value: e.target.value
                        });
                        var listItemDom = $(listItemHtml);
                        if (e.target.checked) {
                          $(settings.list.container).append(listItemDom);
                        } else {
                          $(settings.list.container).find("#" + e.target.id + "_list").remove();
                        }
                        listItemDom.click(function(e) {
                          $(this).remove();
                          $(listItemTarget).prop("checked", false);
                          $(listItemTarget).trigger("change");
                          e.preventDefault();
                        });
                      }
                    });
                  }
                }
              });
              settings.afterFilter.call(this, settings.instance);
            }
            if (settings.more) {
              $(settings.more).unbind("click");
              $(settings.more).click(function(e) {
                moreCounter += settings.rows;
                request(moreCounter, false, false, true, container);
                e.preventDefault();
              });
            }
            if (settings.onsite) {
              var onsiteMetaTemplate = Search.Templates[settings.onsite.template];

              if (settings.onsite.params) {
                var metaInfos = $.extend({categories: getUrlParam('categories'), keywords: getUrlParam('keywords')}, data.header);
              } else {
                var metaInfos = data.header;
              }

              var onsiteMetaHtml = $.parseHTML(onsiteMetaTemplate(metaInfos));

              if (settings.onsite.container) {
                $(settings.onsite.container).html(onsiteMetaHtml);
                if (data.header.query === "") {
                  $(settings.onsite.container).hide();
                }
              }
            }
            if (settings.template && typeof postTemplate !== "undefined") {
              settings.beforeDocs.call(this, settings.instance);
              $.each(data.docs, function(key, post) {
                var postHtml = postTemplate(post);
                container.append(postHtml);
              });
              if (settings.spinner) {
                $(settings.spinner).hide();
              }
              if (reload) {
                settings.afterReload.call(this, settings.instance);
              }
              settings.afterDocs.call(this, settings.instance);
              if (settings.show) {
                $(settings.show).css('display', 'flex');
              }
            } else {
              errorMessage("template not available");
            }
            if (data.header.found === 0 && settings.show) {
              $(settings.show).hide();
            }
          } else {
            errorMessage("solr response: " + data.header.status);
          }
        } else {
          errorMessage("no solr proxy or object");
        }
      },
      error: function() {
        errorMessage("corrupted api source");
      }
    });
  }
  function errorMessage(message) {
    if (settings.development) {
      console.log(message);
    }
    if (settings.more) {
      $(settings.more).hide();
    }
    if (settings.spinner) {
      $(settings.spinner).hide();
    }
  }
  function randomString(length) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  function urlParam(name) {
    return decodeURIComponent((new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(location.search) || [ null, "" ])[1].replace(/\+/g, "%20")) || null;
  }
  function defaultFilterSet(filter, item) {
    switch (filter.type) {
    //  case "select":
    //   $(filter.container).find('option[value="' + item + '"]').attr({
    //     selected: "false",
    //   });
    //   break;

    //  case "checkbox":
    //   $(filter.container).find('input[type="checkbox"][value="' + item + '"]').attr({
    //     checked: "false",
    //   });
    //   break;

    //  case "radio":
    //   $(filter.container).find('input[type="radio"][value="' + item + '"]').attr({
    //     checked: "false",
    //   });
    //   break;

     case "text":
      $(filter.container).find('input[type="text"][data-filter-name="' + filter.name + '"]').attr({
        value: item,
      });
      break;
    }
  }
  function getUrlParam(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };
};